// 注:追加する時は、stateに初期化処理も追記する
export const INITIALIZE = 1
